export default {
  title: '商品カテゴリ',
  addFirstLevel: '第1レベルカテゴリ追加',
  addSecondLevel: '第2レベルカテゴリ追加',
  categoryName: 'カテゴリ名',
  addModal: '第1レベルカテゴリ追加',
  editModal: 'カテゴリ編集',
  addSecondModal: '第2レベルカテゴリ追加',
  required: 'カテゴリ名を入力してください',
};
